import React from 'react';

import PaginationItem from '../PaginationItem/PaginationItem';

export interface PaginationMiddleItemsProps {
  currentPage: number;
  totalPages: number;
  pageRange: number;
  onChange: (page: number) => void;
}

function PaginationMiddleItems(props: PaginationMiddleItemsProps) {
  function renderItem(page: number) {
    return <PaginationItem key={`pagination-item-${page}`} page={page} {...props} />;
  }

  const { currentPage, pageRange, totalPages } = props;

  // example(s):
  // 1 [2]
  // [1] 2 3
  // 1 2 [3] 4
  // 1 2 [3] 4 5
  if (totalPages <= pageRange) {
    const middle = Array.from({ length: totalPages - 2 }, (v, k) => k + 2);
    return <>{middle.map(renderItem)}</>;
  }

  // example(s):
  // [1] 2 3 4 ... 7
  // 1 [2] 3 4 ... 7
  // 1 2 [3] 4 ... 7
  if (currentPage < pageRange - 1) {
    return (
      <>
        {renderItem(2)}
        {renderItem(3)}
        {renderItem(4)}
      </>
    );
  }

  // example(s):
  // 1 ... 4 5 6 [7]
  // 1 ... 4 5 [6] 7
  // 1 ... 4 [5] 6 7
  if (currentPage >= totalPages - 2) {
    return (
      <>
        {renderItem(totalPages - 3)}
        {renderItem(totalPages - 2)}
        {renderItem(totalPages - 1)}
      </>
    );
  }

  // example(s):
  // 1 ... 3 [4] 5 ... 7
  return (
    <>
      {renderItem(currentPage - 1)}
      {renderItem(currentPage)}
      {renderItem(currentPage + 1)}
    </>
  );
}

export default PaginationMiddleItems;
